import React from 'react';
import { Cron, CronProps } from 'react-js-cron';
import 'react-js-cron/dist/styles.css';

const CronPicker: React.FC<CronProps> = ({ value, setValue }) => {
  return <Cron value={value} setValue={setValue} />;
};
export default CronPicker;
